<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="商品名称">
                <el-input v-model="queryForm.goodsName"></el-input>
            </el-form-item>
            <el-form-item label="品牌名称">
                <el-input v-model="queryForm.brandName"></el-input>
            </el-form-item>
            <el-form-item label="商品类目">
                <el-input v-model="queryForm.cateId"></el-input>
            </el-form-item>
            <el-form-item label="商品UPC">
                <el-input v-model="queryForm.upc"></el-input>
            </el-form-item>
            <el-form-item label="产地省市">
                <el-input v-model="queryForm.productArea"></el-input>
            </el-form-item>
            <el-form-item label="规格型号">
                <el-input v-model="queryForm.model"></el-input>
            </el-form-item>
            <el-form-item label="SKUID">
                <el-input v-model="queryForm.skuId"></el-input>
            </el-form-item>
            <el-form-item label="供货天数">
                <el-input v-model="queryForm.deliveryTime"></el-input>
            </el-form-item>
            <el-form-item label="最少起订">
                <el-input v-model="queryForm.minBuyNum"></el-input>
            </el-form-item>
            <el-form-item label="商品来源">
                <el-input v-model="queryForm.importType"></el-input>
            </el-form-item>
            <el-form-item label="内部编码">
                <el-input v-model="queryForm.companyMaterialNo"></el-input>
            </el-form-item>
            <el-form-item label="电商链接">
                <el-input v-model="queryForm.supMallGoodsUrl"></el-input>
            </el-form-item>
            <el-form-item label="商品价格">
                <el-input v-model="queryForm.supMallGoodsPrice"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getYouzhicaiProductList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-upload2"
                        :disabled="multipleSelection.length <= 0"
                        @click="updateSkuState(null,1)"
                    >上架
                    </el-button>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-download"
                        :disabled="multipleSelection.length <= 0"
                        @click="updateSkuState(null,0)"
                    >下架
                    </el-button>
<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        size="small"-->
<!--                        icon="el-icon-plus"-->
<!--                        @click="addYouzhicaiProduct"-->
<!--                    >新建-->
<!--                    </el-button>-->
<!--                    <el-button-->
<!--                        type="warning"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-edit"-->
<!--                        :disabled="multipleSelection.length != 1"-->
<!--                        @click="editYouzhicaiProduct(null)"-->
<!--                    >修改-->
<!--                    </el-button>-->
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-delete"-->
<!--                        :disabled="multipleSelection.length <= 0"-->
<!--                        @click="deleteYouzhicaiProduct(null)"-->
<!--                    >删除-->
<!--                    </el-button>-->
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportYouzhicaiProductList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class="icon-box"
                        @click="refreshYouzhicaiProductList"
                    >
                      <Icon color="#606266">
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="youzhicaiProductList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="goodsName"
                    label="商品名称"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="imagePath"
                    label="商品主图"
                    width="180"
                >
                    <template slot-scope='scope'>
                        <el-image
                            @click='updateSrcList(scope.row.imagePath)'
                            style='width: 80px; height: 80px'
                            :src='scope.row.imagePath'
                            :preview-src-list='srcList'
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="status"
                    label="商品状态"
                    width="180"
                >
                    <template scope="scope">
                        <el-tag type="info" v-if="scope.row.status == 1">{{computeProductStatusEnum(scope.row.status)}}</el-tag>
                        <el-tag type="success" v-if="scope.row.status == 2">{{computeProductStatusEnum(scope.row.status)}}</el-tag>
                        <el-tag type="warning" v-if="scope.row.status == 3">{{computeProductStatusEnum(scope.row.status)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="unit"
                    label="售卖单位"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="stock"
                    label="剩余库存"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="brandName"
                    label="品牌名称"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="cateId"
                    label="商品类目编码"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="upc"
                    label="商品UPC码"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="productArea"
                    label="产地省市"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="model"
                    label="规格型号"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="skuId"
                    label="商品SKU ID"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="deliveryTime"
                    label="供货周期，天"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="minBuyNum"
                    label="最小起订量"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="importType"
                    label="商品来源"
                    width="180"
                >
                    <template slot-scope="scop">
                        <span v-if="scop.row.importType == 0">供应商</span>
                        <span v-if="scop.row.importType == 1">电商</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="companyMaterialNo"
                    label="企业内部物资编码"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="supMallGoodsUrl"
                    label="商品在电商商城的免登录链接"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="supMallGoodsPrice"
                    label="商品在电商商城的价格"
                    width="180"
                ></el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
<!--                            <div @click="checkYouzhicaiProduct(scop.row.id)">-->
<!--                                <Icon size="16">-->
<!--                                    <Eye24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label">查看</span>-->
<!--                            </div>-->
                            <div @click="editYouzhicaiProduct(scop.row.id)" v-if="scop.row.status == 2">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="updateSkuState(scop.row.id,0)" v-if="scop.row.status == 2">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">下架</span>
                            </div>
                            <div @click="updateSkuState(scop.row.id,1)" v-else>
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">上架</span>
                            </div>

<!--                            <div @click="deleteYouzhicaiProduct(scop.row.id)">-->
<!--                                <Icon size="16" style="color: red">-->
<!--                                    <Delete24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label" style="color: red">删除</span>-->
<!--                            </div>-->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
<!--            <el-dialog-->
<!--                :title="youzhicaiProductStates[youzhicaiProductState]"-->
<!--                :visible.sync="showDialog"-->
<!--                width="60%"-->
<!--                @close="closeDialog"-->
<!--            >-->
<!--                <div>-->
<!--                    <el-form-->
<!--                        :model="youzhicaiProduct"-->
<!--                        ref="youzhicaiProductForm"-->
<!--                        :rules="rules"-->
<!--                        label-width="120px"-->
<!--                        :inline="true"-->
<!--                        size="small"-->
<!--                    >-->
<!--                        <el-form-item-->
<!--                            label="商品名称"-->
<!--                            prop="goodsName"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.goodsName"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="售卖单位"-->
<!--                            prop="unit"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.unit"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="商品主图"-->
<!--                            prop="imagePath"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.imagePath"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="品牌名称"-->
<!--                            prop="brandName"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.brandName"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="商品类目编码"-->
<!--                            prop="cateId"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.cateId"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="商品UPC"-->
<!--                            prop="upc"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.upc"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="产地省市"-->
<!--                            prop="productArea"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.productArea"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="规格型号"-->
<!--                            prop="model"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.model"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="商品详情"-->
<!--                            prop="introduction"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.introduction"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="商品SKUID"-->
<!--                            prop="skuId"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.skuId"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="供货周期(天)"-->
<!--                            prop="deliveryTime"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.deliveryTime"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="最少起订"-->
<!--                            prop="minBuyNum"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.minBuyNum"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="商品来源"-->
<!--                            prop="importType"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.importType"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="物资编码"-->
<!--                            prop="companyMaterialNo"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.companyMaterialNo"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="电商链接"-->
<!--                            prop="supMallGoodsUrl"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.supMallGoodsUrl"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="商品价格"-->
<!--                            prop="supMallGoodsPrice"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="youzhicaiProduct.supMallGoodsPrice"-->
<!--                                :disabled="youzhicaiProductState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-form>-->
<!--                </div>-->

<!--                <div-->
<!--                    slot="footer"-->
<!--                    class="flex justify-end"-->
<!--                >-->
<!--                    <el-button @click="closeDialog">关闭</el-button>-->
<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        @click="submitForm"-->
<!--                        v-if="youzhicaiProductState != 'check'"-->
<!--                    >确定-->
<!--                    </el-button>-->
<!--                </div>-->
<!--            </el-dialog>-->
            <edit-youzhicai-product
                :showDialog="showDialog"
                :shopProduct="youzhicaiProduct"
                @closeDialog="closeDialog"
                @submitForm="submitFormEdit"
            >
            </edit-youzhicai-product>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular, } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import EditYouzhicaiProduct from '@/components/youzhicai/editYouzhicaiProduct.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        EditYouzhicaiProduct
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetYouzhicaiProductList();
                this.getYouzhicaiProductList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetYouzhicaiProductList();
                this.getYouzhicaiProductList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            srcList: [''],//大图预览
            productStatusEnumList: [], // 商品状态枚举

            queryForm: {
                goodsName: '', //商品名称
                unit: '', //售卖单位
                imagePath: '', //商品主图
                brandName: '', //品牌名称
                cateId: '', //商品类目编码
                upc: '', //商品UPC码
                productArea: '', //产地省市
                model: '', //规格型号
                introduction: '', //商品详情
                skuId: '', //商品SKU ID
                deliveryTime: '', //供货周期，天
                minBuyNum: '', //最小起订量
                importType: '', //商品来源：0-供应商，1-电商
                companyMaterialNo: '', //企业内部物资编码
                supMallGoodsUrl: '', //商品在电商商城的免登录链接
                supMallGoodsPrice: '' //商品在电商商城的价格
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            youzhicaiProductState: 'add',
            youzhicaiProductStates: {
                add: '新建youzhicai_product',
                check: '查看youzhicai_product',
                edit: '修改youzhicai_product'
            },

            multipleSelection: [],
            youzhicaiProductList: [],
            youzhicaiProduct: {
                id: '', //id
                goodsName: '', //商品名称
                unit: '', //售卖单位
                imagePath: '', //商品主图
                brandName: '', //品牌名称
                cateId: '', //商品类目编码
                upc: '', //商品UPC码
                productArea: '', //产地省市
                model: '', //规格型号
                introduction: '', //商品详情
                skuId: '', //商品SKU ID
                deliveryTime: '', //供货周期，天
                minBuyNum: '', //最小起订量
                importType: '', //商品来源：0-供应商，1-电商
                companyMaterialNo: '', //企业内部物资编码
                supMallGoodsUrl: '', //商品在电商商城的免登录链接
                supMallGoodsPrice: '', //商品在电商商城的价格
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //修改人
                updateTime: '', //修改时间
                deleteFlag: '' //是否删除
            },
            btnLoading: false,

            rules: {
                goodsName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                unit: [{ required: true, message: '售卖单位不能为空', trigger: 'blur' }],
                imagePath: [{ required: true, message: '商品主图不能为空', trigger: 'blur' }],
                brandName: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
                cateId: [{ required: true, message: '商品类目编码不能为空', trigger: 'blur' }],
                upc: [{ required: true, message: '商品UPC码不能为空', trigger: 'blur' }],
                productArea: [{ required: true, message: '产地省市不能为空', trigger: 'blur' }],
                model: [{ required: true, message: '规格型号不能为空', trigger: 'blur' }],
                introduction: [{ required: true, message: '商品详情不能为空', trigger: 'blur' }],
                skuId: [{ required: true, message: '商品SKU ID不能为空', trigger: 'blur' }],
                deliveryTime: [{ required: true, message: '供货周期，天不能为空', trigger: 'blur' }],
                minBuyNum: [{ required: true, message: '最小起订量不能为空', trigger: 'blur' }],
                importType: [{ required: true, message: '商品来源：0-供应商，1-电商不能为空', trigger: 'blur' }],
                companyMaterialNo: [{ required: true, message: '企业内部物资编码不能为空', trigger: 'blur' }],
                supMallGoodsUrl: [{ required: true, message: '商品在电商商城的免登录链接不能为空', trigger: 'blur' }],
                supMallGoodsPrice: [{ required: true, message: '商品在电商商城的价格不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getYouzhicaiProductList();
        this.getProductStatusEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetYouzhicaiProductList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.youzhicaiProductList = [];
        },
        resetDialog() {
            this.youzhicaiProductState = 'add';
            this.showDialog = false;
            this.queryForm = {
                goodsName: '', //商品名称
                unit: '', //售卖单位
                imagePath: '', //商品主图
                brandName: '', //品牌名称
                cateId: '', //商品类目编码
                upc: '', //商品UPC码
                productArea: '', //产地省市
                model: '', //规格型号
                introduction: '', //商品详情
                skuId: '', //商品SKU ID
                deliveryTime: '', //供货周期，天
                minBuyNum: '', //最小起订量
                importType: '', //商品来源：0-供应商，1-电商
                companyMaterialNo: '', //企业内部物资编码
                supMallGoodsUrl: '', //商品在电商商城的免登录链接
                supMallGoodsPrice: '' //商品在电商商城的价格
            };
            this.getYouzhicaiProductList();
        },
        closeDialog() {
            this.showDialog = false;
            this.youzhicaiProduct = {
                id: '', //id
                goodsName: '', //商品名称
                unit: '', //售卖单位
                imagePath: '', //商品主图
                brandName: '', //品牌名称
                cateId: '', //商品类目编码
                upc: '', //商品UPC码
                productArea: '', //产地省市
                model: '', //规格型号
                introduction: '', //商品详情
                skuId: '', //商品SKU ID
                deliveryTime: '', //供货周期，天
                minBuyNum: '', //最小起订量
                importType: '', //商品来源：0-供应商，1-电商
                companyMaterialNo: '', //企业内部物资编码
                supMallGoodsUrl: '', //商品在电商商城的免登录链接
                supMallGoodsPrice: '', //商品在电商商城的价格
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //修改人
                updateTime: '', //修改时间
                deleteFlag: '' //是否删除
            };
        },
        submitFormEdit(youzhicaiProduct){
            this.youzhicaiProduct = youzhicaiProduct
            this.submitForm();
        },
        submitForm() {

            delete this.youzhicaiProduct.attributes
            post(`/youzhicai/product/edit`, { ...this.youzhicaiProduct }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetYouzhicaiProductList();
                    this.resetDialog();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        addYouzhicaiProduct() {
            this.showDialog = true;
            this.youzhicaiProductState = 'add';
        },
        checkYouzhicaiProduct(youzhicaiProductId) {
            console.log(youzhicaiProductId);
            this.currentYouzhicaiProductId = youzhicaiProductId;

            this.getYouzhicaiProductById();
            this.showDialog = true;
            this.youzhicaiProductState = 'check';
        },
        editYouzhicaiProduct(youzhicaiProductId) {
            console.log('youzhicaiProduct', youzhicaiProductId);
            if (youzhicaiProductId) {
                this.currentYouzhicaiProductId = youzhicaiProductId;
                this.getYouzhicaiProductById();
            } else {
                this.youzhicaiProduct = { ...this.youzhicaiProduct, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.youzhicaiProductState = 'edit';
        },
        deleteYouzhicaiProduct(youzhicaiProductId) {
            let ids = '';
            if (youzhicaiProductId) {
                ids = youzhicaiProductId;
            } else {
                ids = this.multipleSelection.map((youzhicaiProduct) => youzhicaiProduct.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/youzhicai/product/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetYouzhicaiProductList();
                            this.getYouzhicaiProductList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshYouzhicaiProductList() {
            this.resetYouzhicaiProductList();
            this.getYouzhicaiProductList();
        },
        getYouzhicaiProductList(query = {}) {
            this.loading = true;
            get(`/youzhicai/product/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.youzhicaiProductList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getYouzhicaiProductById() {
            get(`/youzhicai/product/get`, { id: this.currentYouzhicaiProductId }).then((res) => {
                if (res.success) {
                    this.youzhicaiProduct = { ...this.youzhicaiProduct, ...res.youzhicaiProduct };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportYouzhicaiProductList() {
            //this.btnLoading = true;
            exprotExcel(`/youzhicai/product/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/youzhicai/product/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/youzhicai/product/importData`, formData);
            this.refreshYouzhicaiProductList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getYouzhicaiProductList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getYouzhicaiProductList();
        },

        // 上架下架
        updateSkuState(youzhicaiProductId,type){
            let ids = '';
            if (youzhicaiProductId) {
                ids = youzhicaiProductId;
            } else {
                let arr = this.multipleSelection.map((youzhicaiProduct) => {
                    if(youzhicaiProduct.status != 1){
                        return youzhicaiProduct.id
                    }
                });
                for (const item of arr) {
                    if(!item){
                        this.$message({
                            message: "未推送商品无法操作",
                            type: 'error',
                            duration: 2000
                        });
                        return;
                    }
                }
                ids = arr.join(",")
            }
            this.$confirm('确定操作所选项吗？', '提示', {
                type: 'warning'
            }).then(() => {
                get("/youzhicai/product/updateSkuState",{ids,type}).then((res)=>{
                    if(res.success){
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                        this.resetYouzhicaiProductList();
                        this.getYouzhicaiProductList();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                })
            })
        },

        // 查看商品大图
        updateSrcList(src) {
            this.srcList[0] = src;
        },

        // 获取商品状态枚举
        getProductStatusEnum(){
            get("/youzhicai/utils/getEnum",{
                enumType: "product_status_enum"
            }).then((res)=>{
                if(res.success){
                    this.productStatusEnumList = res.enumList;
                }
            })
        },

        // 计算商品状态枚举
        computeProductStatusEnum(key){
            for (const item of this.productStatusEnumList) {
                if(item.key == key){
                    return item.value;
                }
            }
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>